var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollaboratorSignatureSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 110,
    viewBox: "0 0 85 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 0H0V110H85V0Z",
    fill: "#F8F9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4049 29.7297H77.7701",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4049 60.946H77.7701",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 78.7839H52.6749",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 56.4863H37.7669",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 34.1895H78.0185",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 65.4053H78.0185",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 38.6487H78.0185",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 69.865H78.0185",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 43.1084H78.0185",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 74.3242H78.0185",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 47.5674H78.0185",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4049 27.7476H77.7701",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4049 58.9641H77.7701",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 76.802H52.6749",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 52.0271H78.0185",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 55H37.7669",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 36.6665H78.0185",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 67.8831H78.0185",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 32.2073H78.0185",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 63.4233H78.0185",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 45.5854H78.0185",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 41.1262H78.0185",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 72.3423H78.0185",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 50.0452H78.0185",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8323 83.9243H54.3522V89.8703H77.8323V83.9243Z",
    fill: "#E1F3FB",
    stroke: "#0166AA",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1412 88.5054C58.3534 88.4903 58.5801 88.3909 58.7685 88.3109C60.0139 87.7822 61.1918 87.0948 62.0683 86.0482C62.2811 85.7942 62.8011 84.9778 62.722 85.2992C62.6629 85.539 62.4847 85.7629 62.3556 85.9667C61.8863 86.7076 61.5615 87.5046 61.2829 88.3319C61.2625 88.3925 61.1092 88.6834 61.138 88.755C61.145 88.7725 61.1739 88.7412 61.188 88.7288C61.3366 88.5971 61.4753 88.445 61.615 88.3056C62.4993 87.4239 63.3633 86.5215 64.2665 85.6592C64.3433 85.5859 64.5302 85.3668 64.5248 85.4726C64.5101 85.7568 64.283 86.0841 64.1663 86.332C63.9529 86.7854 63.7027 87.238 63.5127 87.7012C63.4639 87.82 63.6875 87.7958 63.7393 87.7958C64.087 87.7958 64.3986 87.6644 64.7066 87.5146C64.7897 87.4742 65.1079 87.2307 65.1072 87.2308C64.9077 87.264 64.7478 87.4486 64.6144 87.5856C64.4702 87.7336 64.4786 87.5945 64.4615 87.4069C64.4481 87.2598 64.4645 86.7699 64.733 86.9759C64.8334 87.0529 65.7157 87.8527 65.3971 87.9798C65.1403 88.0822 64.7807 88.0359 64.5142 88.0271C64.0919 88.0132 63.4322 87.9904 63.1173 87.6486C62.8793 87.3903 64.9961 87.2528 65.0361 87.2518C67.0879 87.2016 69.1181 87.604 71.1402 87.8904",
    stroke: "#0166AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6235 16.5371H7.14343V22.4831H30.6235V16.5371Z",
    fill: "#E1F3FB",
    stroke: "#0166AA",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaboratorSignatureSingle);
export default __webpack_public_path__ + "static/media/collaborator-signature-single.5558eaf8b1e0b21ef5d8b29ea5a495fb.svg";
export { ForwardRef as ReactComponent };